import * as React from 'react';

//MUI Components
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getIdSpot, getLivraison, getRidingPeriod, getPanier, getShowPanier } from "../../../../store/selectors.js";
import { showPanierSlice } from "../../../../store/showPanierSlice.js";

//Translate utils :
import { translator } from "../../../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

//created components
import Panier from '../panier/Panier.jsx'

function InfosPanier({ qte, total, articles }) { // component to manage the first step of shopping : choosing place and time

    const dispatch = useDispatch();
    let showCart = useSelector(getShowPanier);
    const lang = useSelector(getLang) //global state : language


    const handleOpen = () => {
        //console.log(showCart);
        dispatch(showPanierSlice.actions.setShowPanier(true));
        //console.log(showCart);
    };
    const handleClose = () => {
        dispatch(showPanierSlice.actions.setShowPanier(false));
    };

    return (
        <div className="infos-panier">
            <div className="infos-panier-top">
                <div className="infos-panier-top-qte">
                    <p className="infos-panier-top-qte-libelle">{translator("Nombre d'articles : ", lang, "infosPanierQte")}</p>
                    <p className="infos-panier-top-qte-valeur">{qte}</p>
                </div>
                <div className="infos-panier-top-total">
                    <p className="infos-panier-top-total-libelle">{translator("Prix total du panier : ", lang, "infosPanierTotal")}</p>
                    <p className="infos-panier-top-total-valeur">{total + ",00€"}</p>
                </div>
            </div>
            <div className="infos-panier-bottom">
                <Button
                    disabled={qte === 0}
                    variant="contained"
                    onClick={handleOpen}
                    className="bt-voir-panier" //stylise in css
                >{translator("Voir le panier : ", lang, "infosPanierVoir")}</Button>
            </div>

            <Modal
                open={showCart}
                onClose={handleClose}
            >
                <Panier articles={articles} />
            </Modal>

        </div>

    )
}




export default InfosPanier